

import { BusinessUnit } from '../../businessunit/model/business-unit.model';
import { FirearmStorageLocation } from '../../firearm_storage_location/model/firearm-storage-location.model';
import { FIREARM_ASSIGNMENT_METADATA } from './firearm-assignment.metadata';
import { FirearmAssignmentBase } from './firearm-assignment.model.base';
import { CrudEntity, CrudEntityConstructionOptions, RepositoryFile } from '@scisys-uim/uim-common';
import { FirearmDocumentType } from './firearm-assignment.types';


export interface FirearmAssignment extends FirearmAssignmentBase {
  gunDealerLocation?: FirearmStorageLocation;
  gunDealerLocationId?: number;
}

export interface FirearmAssignmentTransient {
}

export class FirearmAssignment extends CrudEntity<FirearmAssignment, number, FirearmAssignmentTransient> implements FirearmAssignmentTransient {
  constructor(source?: Partial<FirearmAssignment>, options?: CrudEntityConstructionOptions<FirearmAssignment, number, FirearmAssignmentTransient>) {
    super(FIREARM_ASSIGNMENT_METADATA, source, options);
  }

  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
    this.notifyPolice = this.notifyPolice || false;
    this.buApproved = this.buApproved || false;
    this.leadApproved = this.leadApproved || false;
  }

  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  private _documents?: { [key: string]: RepositoryFile[]; }
  get documents(): { [key: string]: RepositoryFile[] } {
    if (this._documents == null) {
      this._documents = {}
    }
    return this._documents;
  }

  get businessUnit(): BusinessUnit {
    return this.firearm?.asset?.businessUnit;
  }
}





